(() => {
  'use strict';

  // Matches the reference behavior: a milestone activates once its bottom edge
  // clears this many pixels above the viewport bottom, and deactivates when
  // scrolling back up past the same line.
  const ACTIVATION_OFFSET = 200;

  class PdpJourneyTimeline extends HTMLElement {
    connectedCallback() {
      this.milestones = this.querySelectorAll('.pdp-journey-timeline__milestone');
      if (!this.milestones.length) return;

      this.onIntersect = this.onIntersect.bind(this);
      this.observer = new IntersectionObserver(this.onIntersect, {
        rootMargin: `0px 0px -${ACTIVATION_OFFSET}px 0px`,
        threshold: [0, 0.25, 0.5, 0.75, 1],
      });
      this.milestones.forEach((milestone) => this.observer.observe(milestone));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    onIntersect(entries) {
      for (const entry of entries) {
        if (!entry.rootBounds) continue;
        const clearedLine = entry.boundingClientRect.bottom <= entry.rootBounds.bottom;
        const scrolledPast = entry.boundingClientRect.top <= entry.rootBounds.top;
        entry.target.classList.toggle('is-active', clearedLine || scrolledPast);
      }
    }
  }

  if (!customElements.get('pdp-journey-timeline')) {
    customElements.define('pdp-journey-timeline', PdpJourneyTimeline);
  }
})();
